import { VStack, Heading, Text, Box, HStack, Switch } from '@chakra-ui/react'
import { Bell } from 'lucide-react'

interface NotificationSetting {
  id: string
  label: string
  description: string
  category: 'email' | 'push' | 'sms'
}

const notificationSettings: NotificationSetting[] = [
  {
    id: 'email_new_message',
    label: 'Nouveaux messages',
    description: 'Recevoir un email pour les nouveaux messages',
    category: 'email',
  },
  {
    id: 'email_meeting_reminder',
    label: 'Rappel d\'AG',
    description: 'Rappels avant les assemblées générales',
    category: 'email',
  },
  {
    id: 'email_document_shared',
    label: 'Nouveaux documents',
    description: 'Notification lors du partage de documents',
    category: 'email',
  },
  {
    id: 'email_task_assigned',
    label: 'Tâches assignées',
    description: 'Notification quand une tâche vous est assignée',
    category: 'email',
  },
]

export function NotificationsPage() {
  return (
    <VStack align="stretch" gap={6}>
      {/* Header */}
      <VStack align="start" gap={2}>
        <HStack gap={2}>
          <Bell size={24} />
          <Heading as="h2" fontSize="2xl">
            Notifications
          </Heading>
        </HStack>
        <Text color="gray.600">
          Gérez vos préférences de notifications
        </Text>
      </VStack>

      {/* Email Notifications */}
      <VStack align="stretch" gap={4}>
        <Heading as="h3" fontSize="lg">
          Notifications par email
        </Heading>

        {notificationSettings.map((setting) => (
          <Box
            key={setting.id}
            p={4}
            bg="white"
            borderRadius="lg"
            border="1px solid"
            borderColor="gray.200"
          >
            <HStack justify="space-between" align="start">
              <VStack align="start" gap={1} flex={1}>
                <Text fontWeight="medium">{setting.label}</Text>
                <Text fontSize="sm" color="gray.600">
                  {setting.description}
                </Text>
              </VStack>
              <Switch.Root defaultChecked>
                <Switch.Control>
                  <Switch.Thumb />
                </Switch.Control>
              </Switch.Root>
            </HStack>
          </Box>
        ))}
      </VStack>

      {/* Coming Soon: Push & SMS Notifications */}
      <Box
        p={6}
        bg="gray.50"
        borderRadius="lg"
        border="1px dashed"
        borderColor="gray.300"
        textAlign="center"
      >
        <Text color="gray.600" fontSize="sm">
          Notifications push et SMS à venir
        </Text>
      </Box>
    </VStack>
  )
}
